/*
 *   File : BasketCard.jsx
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations :
 *   Version : 1.0.0
 */

import React from "react";
import { PrimaryButton } from "../Cta";
import Icon from "../icons";

export default function BasketCard(props) {
  const handleChange = () => {
    props.handleView();
  };
  return (
    <div
      onClick={handleChange}
      style={{ backgroundColor: props.BgColor }}
      className={`${props.bgColor} ${
        props.borderColor
      } d-flex flex-column justify-content-between h-100 w-100 e-cursor-pointer ${
        !props.NoAnimation ? "e-transition-scale" : ""
      } e-border-radius-16 e-p-12px e-primary-font-poppins`}
    >
      <div className="d-flex align-items-center">
        <div
          style={{ width: 44, height: 44 }}
          className="bg-white rounded-circle d-flex justify-content-center align-items-center overflow-hidden e-drop-basket-shadow"
        >
          <img
            src={props.img && props.img.trim() !== "" ? props.img : null}
            width={44}
            alt="Basket Visual"
            className=" object-fit-contain "
          />
        </div>

        <div className="d-flex flex-column row-gap-2 ms-2">
          <h4 className="e-primary-font-poppins e-font-weight-600 e-text-eerie-black e-font-14 line-height-18 m-0">
            {props.title}
          </h4>

          <div className="d-flex column-gap-2 flex-wrap">
            {typeof props.badges === "string" ? (
              <p
                className={`m-0 e-border-gradient text-black px-2 e-w-fit e-primary-font-poppins e-font-weight-400 e-font-10 line-height-16px`}
              >
                {props.badges}
              </p>
            ) : (
              props.badges.map((badge, index) => (
                <p
                  key={index}
                  className={`m-0 e-border-gradient text-black px-2 e-w-fit e-primary-font-poppins e-font-weight-400 e-font-10 line-height-16px`}
                >
                  {badge}
                </p>
              ))
            )}
          </div>
        </div>
      </div>

      {props.type !== 2 ? (
        <div className="d-flex e-pt-12px pb-2">
          <p className="mt-3 m-0 e-font-weight-400 e-font-10 e-primary-font-poppins">
            {props.content}
          </p>
        </div>
      ) : (
        ""
      )}

      {props.type === 2 ? (
        <div className="row row-cols-2 e-pt-20px ps-3 ">
          <div className="col pt-2">
            {props.recommended && (
              <div className="d-flex align-items-center">
                <img
                  src={require("../../Assets/Image/flame.svg").default}
                  alt="highly recommended"
                  className="e-drop-basket-shadow "
                />
                <p className="e-primary-font-poppins e-font-weight-400 e-font-8 m-0 ps-2">
                  Highly recommended
                </p>
              </div>
            )}
          </div>
          <div className="col d-flex justify-content-end">
            <div className="d-flex align-items-center column-gap-1 e-cursor-pointer">
              <PrimaryButton
                name="View Details"
                ClassName="bg-transparent e-text-blue-violet p-0 e-font-12 e-font-weight-500"
                onPress={handleChange}
              />
              <Icon icon="right-blue" size="12px" color="#9b81f5" />
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-between pt-3">
          <div className="d-flex flex-column e-primary-font-poppins">
            <p className="m-0 e-font-weight-500 e-font-10 line-height-12px pb-1">
              {props.returnYear} returns
            </p>
            <h5 className="m-0 pb-1 e-font-weight-600 e-font-16 line-height-20px e-text-persian-green">
              {props.returns}%
            </h5>
          </div>

          <div className="d-flex align-items-center e-cursor-pointer">
            <PrimaryButton
              name="View Details"
              ClassName="bg-transparent e-text-blue-violet p-0 e-font-12 e-font-weight-500"
              onPress={handleChange}
            />
            <Icon icon="right-blue" size="12px" color="#9b81f5" />
          </div>
        </div>
      )}
      {props.type === 3 && (
        <img
          src={require("../../Assets/Image/reccomended2.png")}
          alt="recomended"
          className="e-recommended-tag z-0"
        />
      )}
    </div>
  );
}
